import "./index.css";

import logo from "./assets/logo.png";

export function App() {
  return (
    <div className="landing-bg flex flex-col items-center justify-center min-h-screen gap-6 p-8">
      <img
        src={logo}
        alt="comuu"
        className="logo-glow h-32 w-auto fade-in-up"
      />

      <h1 className="text-7xl font-bold fade-in-up delay-1">
        <span className="text-comuu-carbon">co</span><span className="text-comuu-emerald">muu</span>
      </h1>

      <p className="text-comuu-muted text-2xl tracking-widest uppercase fade-in-up delay-2">
        Em breve
      </p>
    </div>
  );
}
